import React from 'react';
import { ClickAwayListener, Grow, Paper, Popper } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    paper: {
        borderRadius: 6,
        position: 'relative',
        border: `1px solid ${theme.palette.grey[200]}`,

        '&:before': {
            content: '""',
            backgroundColor: theme.palette.common.white,
            transform: 'translate(50%, -50%) rotate(45deg)',
            borderLeft: `1px solid ${theme.palette.grey[200]}`,
            borderTop: `1px solid ${theme.palette.grey[200]}`,

            /* Position at the top center */
            left: 'calc(50% - 10px)',
            position: 'absolute',
            top: 0,

            /* Size */
            height: 10,
            width: 10,
        },
    },
}));

const CustomPopper = props => {
    const { open, anchorEl, children, handleClose } = props;
    const classes = useStyles();

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            style={{ zIndex: 10000 }}
            role={undefined}
            transition
        >
            {({ TransitionProps }) => (
                <Grow {...TransitionProps} style={{ transformOrigin: 'center bottom' }}>
                    <Paper className={classes.paper} elevation={4}>
                        <ClickAwayListener onClickAway={handleClose}>{children}</ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
};

export default CustomPopper;
